import { SvgIcon } from "@mui/material"

import { ReactComponent as ClosedIcon } from "./closed.svg"

export const StatusClosedIcon = (props) => {
    return (
        <SvgIcon component={ClosedIcon} {...props} inheritViewBox />
    )
}